import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { blue, navy, glass, glowSm, transition } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Radio', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}-wrapper${DOT_PREFIX}`]: {
      [`${componentCls}-inner`]: {
        borderColor: `${navy[700]} !important`,
        background: `${glass.input} !important`,
        transition,
      },

      '&:hover': {
        [`${componentCls}-inner`]: {
          borderColor: `${blue[500]}60 !important`,
        },
      },

      [`${componentCls}-checked`]: {
        [`${componentCls}-inner`]: {
          borderColor: `${blue[500]} !important`,
          background: `${glass.input} !important`,
          boxShadow: glowSm,

          '&:after': {
            background: `${blue[500]} !important`,
          },
        },
      },
    },
  }
})
